
import {configureStore} from "@reduxjs/toolkit"
import UndoRedo from "../undoRedo/UndoRedo"

  const store = configureStore({
    reducer:{undoRedo:UndoRedo}
})

export default store